import { Injectable } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { ModalComponent } from './modal.component';

@Injectable()
export class ModalService {
  modalData: Object = null;

  private modalActive: boolean = false;
  private currentModalDirective: ModalDirective;
  private currentModalComponent: ModalComponent;

  constructor() {
  }

  public isModalActive() {
    return this.modalActive;
  }

  public setModalActive(status: boolean) {
    this.modalActive = status;
    if (this.modalActive) this.currentModalDirective.show();
    else this.currentModalDirective.hide();
  }

  public setCurrentModal(
    modalDirective: ModalDirective,
    modalComponent: ModalComponent
  ) {
    this.currentModalDirective = modalDirective;
    this.currentModalComponent = modalComponent;
  }

  public closeCurrentModal() {
    this.currentModalDirective.hide();
  }

  createNewModal(modalData: Object) {
    this.modalData = modalData;
  }
}
